import React from 'react';
import dynamic from 'next/dynamic';

// Dynamically import HelmProvider to avoid loading Helm CSS unless needed
const HelmProvider = dynamic(
  () => import('mkt-ssr/components/UiEngineProvider/HelmProvider'),
  {
    ssr: true, // Enable SSR for the dynamic component
  },
);

// Dynamically import SailProvider to avoid loading Sail dependencies unless needed
const SailProvider = dynamic(
  () => import('mkt-ssr/components/UiEngineProvider/SailProvider'),
  {
    ssr: true,
  },
);

interface UiEngineProviderProps {
  uiEngine: 'sail' | 'helm' | 'none';
  children: React.ReactNode;
}

export function UiEngineProvider({uiEngine, children}: UiEngineProviderProps) {
  if (uiEngine === 'sail') {
    return <SailProvider>{children}</SailProvider>;
  } else if (uiEngine === 'none') {
    return <>{children}</>;
  }

  // For helm, use the dynamically imported HelmProvider
  return <HelmProvider>{children}</HelmProvider>;
}
